import '@tencent/tpm-meeting/lib/ComHero/style';
import React, { useContext, useRef } from 'react';
import styles from './index.module.scss';
import ProductDetailContext from '../../context/ProductDetailContext';
import {
  PackageNodeTypeBaseline,
  PackageNodeTypePatch,
  PatchPageDetails
} from '@/tpss/types';
import {
  Affix,
  Anchor,
  Link,
  message,
  PrimaryTable,
  TdAnchorProps,
  Space
} from 'tdesign-react';
import { convertDBTimestampToDateStr } from '@/tpss/utils/utils';
import AnchorItem from 'tdesign-react/es/anchor/AnchorItem';
import yaml from 'js-yaml';
import { auditLog } from '@/tpss/apis/api';
import ResourceRequirement from '../ResourceRequirement';
const ProductPackageNodeDetails: React.FC = () => {
  // const [packages, setPackages] = useState<ProductPackage[]>([]);

  const { targetPackageData } = useContext(ProductDetailContext);
  const { softwareDownloadData } = useContext(ProductDetailContext);
  const { materialDownloadData } = useContext(ProductDetailContext);
  const { toolDownloadData } = useContext(ProductDetailContext);

  const { currentProductVersion } = useContext(ProductDetailContext);
  const { currentSoftwareType } = useContext(ProductDetailContext);
  const { patchPage } = useContext(ProductDetailContext);
  const DEFAULT_TIMESTAMP = '0001-01-01T00:00:00Z';
  const DEFAULT_UPDATE_DATE = '2025-01-01';

  const downloadFile = (url: string) => {
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // const onDownload = async () => {
  //   // await checkAndRecord(() => {
  //   //   message.info('开始下载…');
  //   //   downloadFile(downloadUrl || '');
  //   // });
  //   downloadFile(downloadUrl || '')
  // };

  function onDownload(row) {
    auditLog(row.url, 'download-file', row.filename, {
      ProductID: String(currentProductVersion?.ProductID ?? ''),
      ProductVersionName: currentProductVersion?.ProductVersionName ?? '',
      PackageNodeName: targetPackageData?.ProductPackageNodeName ?? '',
      PackageNodeType: targetPackageData?.ProductPackageNodeType ?? '',
      DownloadURL: row.url
    });
    if (row.url === '') {
      window.location.replace(
        `https://cloud.tencent.com/login?s_url=${encodeURIComponent(
          window.location.href
        )}`
      );
    } else {
      if (row.url === '-') {
        message.info('您尚未开通该软件包官网下载通道，如有需要请联系客服对接开通。');
      } else {
        downloadFile(row.url);
      }
    }
  }

  function onCopyDownloadUrl(row) {
    auditLog(row.url, 'copy-download-url', row.filename, {
      ProductID: String(currentProductVersion?.ProductID ?? ''),
      ProductVersionName: currentProductVersion?.ProductVersionName ?? '',
      PackageNodeName: targetPackageData?.ProductPackageNodeName ?? '',
      PackageNodeType: targetPackageData?.ProductPackageNodeType ?? '',
      DownloadURL: row.url
    });
    if (row.url === '') {
      window.location.replace(
        `https://cloud.tencent.com/login?s_url=${encodeURIComponent(
          window.location.href
        )}`
      );
    } else {
      if (row.url === '-') {
        message.info('您尚未开通该软件包官网下载通道，如有需要请联系客服对接开通。');
      } else {
        const wgetCommand = `wget '${row.url}' -O '${row.filename}'`;
        navigator.clipboard
          .writeText(wgetCommand)
          .then(() => {
            message.info('复制下载地址成功');
          })
          .catch(() => {
            // 如果clipboard API不可用，使用fallback方法
            const textArea = document.createElement('textarea');
            textArea.value = wgetCommand;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            message.info('复制下载地址成功');
          });
      }
    }
  }

  const downloadColumn = [
    { colKey: 'filename', title: '文件' },
    { colKey: 'description', title: ' 描述' },
    { colKey: 'size', title: '文件大小' },
    { colKey: 'md5', title: 'sha256' },
    {
      colKey: 'manipulate',
      title: '操作',
      cell: ({ row }) => (
        <Space>
          <Link theme="primary" hover="color" onClick={() => onDownload(row)}>
            下载
          </Link>
          <Link theme="primary" hover="color" onClick={() => onCopyDownloadUrl(row)}>
            复制下载地址
          </Link>
        </Space>
      )
    }
  ];

  function getSelectedPackageName() {
    if (targetPackageData) {
      // console.log('targetPackageData');
      // console.log(targetPackageData);
      return targetPackageData?.ProductPackageNodeName;
    }
    return '';
  }

  function getPackageTypeName() {
    if (targetPackageData) {
      if (targetPackageData?.ProductPackageNodeType === PackageNodeTypeBaseline) {
        return '安装包';
      }
      if (targetPackageData?.ProductPackageNodeType === PackageNodeTypePatch) {
        return '补丁包';
      }
    }
    return '';
  }

  function softwareDownloadTableNeedVisible() {
    return softwareDownloadData.length > 0;
  }

  function materialDownloadTableNeedVisible() {
    return materialDownloadData.length > 0;
  }

  function toolDownloadTableNeedVisible() {
    return toolDownloadData.length > 0;
  }
  function getValidTimestampField(data: any, fieldName: string): string | null {
    if (data[fieldName] && data[fieldName] !== DEFAULT_TIMESTAMP) {
      return convertDBTimestampToDateStr(data[fieldName]);
    }
    return null;
  }
  function getPatchUpdateTime() {
    if (!targetPackageData) {
      return DEFAULT_UPDATE_DATE;
    }
    const releaseTime = getValidTimestampField(targetPackageData, 'ReleaseTime');
    if (releaseTime) {
      return releaseTime;
    }
    const createdAt = getValidTimestampField(targetPackageData, 'CreatedAt');
    if (createdAt) {
      return createdAt;
    }
    return DEFAULT_UPDATE_DATE;
  }

  const bottomRef = useRef<any>(null);

  function packageNodeDetailsNeedDisplay() {
    if (currentSoftwareType === PackageNodeTypeBaseline) {
      return true;
    }
    if (
      currentSoftwareType === PackageNodeTypePatch &&
      patchPage === PatchPageDetails
    ) {
      return true;
    } else {
      return false;
    }
  }

  function getReleaseNotesDataFromYaml() {
    if (!targetPackageData?.ProductPackageNodeChangeLog) {
      return [];
    }
    try {
      return yaml.load(targetPackageData?.ProductPackageNodeChangeLog);
    } catch (error) {
      return [];
    }
  }

  function resourceRequirementNeedVisible() {
    return (
      targetPackageData?.ResourceRequirement &&
      targetPackageData.ResourceRequirement.trim() !== ''
    );
  }

  function getResourceRequirementDescription() {
    if (!targetPackageData?.ResourceRequirement) {
      return '';
    }
    try {
      const resourceData = yaml.load(targetPackageData.ResourceRequirement);
      return resourceData?.description || '';
    } catch (error) {
      return '';
    }
  }

  function renderAnchorItems() {
    // console.log('renderAnchorItems');
    const releaselogData = getReleaseNotesDataFromYaml();
    return releaselogData.map((item: any, index: number) => (
      <>
        <AnchorItem
          className={styles.ToCTopLevelAnchor}
          key={item.name + index}
          title={item.name}
          href={'#' + item.name + '_' + index}
        ></AnchorItem>
        {/* {getSubSystemAnchor(item)} */}
      </>
    ));
  }
  // function getSubSystemAnchor(productItem) {
  //   return productItem.subsystem?.map((item: any, index: number) => (
  //     <AnchorItem
  //       className={styles.ToCSecondLevelAnchor}
  //       key={productItem.name + index} // 最好使用item.id等唯一值
  //       title={item.name}
  //       href={'#' + item.name + '_' + index}
  //     ></AnchorItem>
  //   ));
  // }

  const handleClick: TdAnchorProps['onClick'] = ({ e, href, title }) => {
    e.preventDefault();
    // console.log('handleClick', href, title);
  };

  function getReleaseNoteBody() {
    // console.log('------- load release note');
    const releaselogData = getReleaseNotesDataFromYaml();
    // console.log('getReleaseNoteBody', releaselogData);
    return releaselogData.map((item: any, index: number) => (
      <>
        <h2 key={item.name + index} id={item.name + '_' + index}>
          {item.name}
        </h2>
        {getSubSystemNoteBody(item)}
        {getItemsContent(item)}
      </>
    ));
  }
  function getSubSystemNoteBody(productItem) {
    return productItem.subsystem?.map((item: any, index: number) => (
      <>
        {/* id={item.name + '_' + index} */}
        <h3 key={item.name + index}>{item.name}</h3>
        {getItemsContent(item)}
      </>
    ));
  }

  function getItemsContent(category) {
    return category.items?.map((item: any, index: number) => (
      <p key={item + index}>{item}</p>
    ));
  }

  return (
    <>
      <div
        className={styles.ToCContainer}
        style={{
          display: packageNodeDetailsNeedDisplay() ? '' : 'none'
        }}
      >
        <Affix offsetTop={150}>
          <h2 className={styles.ToCContainerTitle}>本页目录:</h2>
          <Anchor
            targetOffset={150}
            // affixProps={{ offsetTop: 150 }}
            onClick={handleClick}
          >
            <AnchorItem
              className={styles.ToCTopLevelAnchor}
              style={{
                display: softwareDownloadTableNeedVisible() ? '' : 'none'
              }}
              key={'软件下载'} // 最好使用item.id等唯一值
              title={'软件下载'}
              href={'#软件下载'}
            ></AnchorItem>
            <AnchorItem
              className={styles.ToCTopLevelAnchor}
              style={{
                display: toolDownloadTableNeedVisible() ? '' : 'none'
              }}
              key={'工具下载'} // 最好使用item.id等唯一值
              title={'工具下载'}
              href={'#工具下载'}
            ></AnchorItem>
            <AnchorItem
              className={styles.ToCTopLevelAnchor}
              style={{
                display: materialDownloadTableNeedVisible() ? '' : 'none'
              }}
              key={'资料下载'} // 最好使用item.id等唯一值
              title={'资料下载'}
              href={'#资料下载'}
            ></AnchorItem>
            <AnchorItem
              className={styles.ToCTopLevelAnchor}
              style={{
                display: resourceRequirementNeedVisible() ? '' : 'none'
              }}
              key={'资源需求'} // 最好使用item.id等唯一值
              title={'资源需求'}
              href={'#资源需求'}
            ></AnchorItem>
            <AnchorItem
              className={styles.ToCTopLevelAnchor}
              key={'发布说明'} // 最好使用item.id等唯一值
              title={'发布说明'}
              href={'#发布说明'}
            >
              {renderAnchorItems()}
            </AnchorItem>
          </Anchor>
        </Affix>
      </div>

      <div
        style={{
          display: packageNodeDetailsNeedDisplay() ? '' : 'none'
        }}
      >
        <div className={styles.softwareDetailsHeader}>
          <h3 className={styles.softwareDetailsHeaderTitle}>
            {getSelectedPackageName()}&nbsp;-&nbsp;
            {getPackageTypeName()}
          </h3>
          <div className={styles.softwareDetailsHeaderUpdateTime}>
            发布时间 {getPatchUpdateTime()}
          </div>
        </div>
        <div className={styles.softwareContentBlock}>
          <h3 className={styles.softwareContentBlockTitle}>软件包说明</h3>
          <div className={styles.softwareContentBlockContent}>
            <div className={styles.patchNode}>
              {targetPackageData?.ProductPackageNodeDescription}
            </div>
          </div>
        </div>
        <div
          style={{
            display: softwareDownloadTableNeedVisible() ? '' : 'none'
          }}
        >
          <div className={styles.softwareContentBlock} ref={bottomRef}>
            <h3 className={styles.softwareContentBlockTitle} id="软件下载">
              软件下载
            </h3>
            <div className={styles.softwareContentBlockContent}>
              <PrimaryTable
                columns={downloadColumn}
                data={softwareDownloadData}
                rowKey="index"
                size="medium"
                tableLayout="fixed"
                verticalAlign="middle"
              />
            </div>
          </div>
        </div>
        <div
          style={{
            display: toolDownloadTableNeedVisible() ? '' : 'none'
          }}
        >
          <div className={styles.softwareContentBlock}>
            <h3 className={styles.softwareContentBlockTitle} id="工具下载">
              工具下载
            </h3>
            <div className={styles.softwareContentBlockContent}>
              <PrimaryTable
                columns={downloadColumn}
                data={toolDownloadData}
                rowKey="index"
                size="medium"
                tableLayout="fixed"
                verticalAlign="middle"
              />
            </div>
          </div>
        </div>
        <div
          style={{
            display: materialDownloadTableNeedVisible() ? '' : 'none'
          }}
        >
          <div className={styles.softwareContentBlock} ref={bottomRef}>
            <h3 className={styles.softwareContentBlockTitle} id="资料下载">
              资料下载
            </h3>
            <div className={styles.softwareContentBlockContent}>
              <PrimaryTable
                columns={downloadColumn}
                data={materialDownloadData}
                rowKey="index"
                size="medium"
                tableLayout="fixed"
                verticalAlign="middle"
              />
            </div>
          </div>
        </div>
        <div
          className={styles.softwareContentBlock}
          style={{
            display: resourceRequirementNeedVisible() ? '' : 'none'
          }}
        >
          <h3 className={styles.softwareContentBlockTitle} id="资源需求">
            资源需求
          </h3>
          {getResourceRequirementDescription() && (
            <div className={styles.softwareContentBlockContent}>
              <p>{getResourceRequirementDescription()}</p>
            </div>
          )}
          <div className={styles.softwareContentBlockContent}>
            <ResourceRequirement
              resourceRequirement={targetPackageData?.ResourceRequirement || ''}
            />
          </div>
        </div>
        <div className={styles.softwareContentBlock}>
          <h3 className={styles.softwareContentBlockTitle} id="发布说明">
            发布说明(ReleaseNote)
          </h3>
          <div className={styles.softwareContentBlockContent}>
            {getReleaseNoteBody()}
          </div>
        </div>
        {/* <div style={{ position: 'fixed', top: 60, right: 0 }}>
        <p>bbbb</p>
        <Affix offsetTop={10} offsetBottom={10}>
          <Button>固钉</Button>
        </Affix>
      </div> */}
      </div>
    </>
  );
};

export default ProductPackageNodeDetails;
